module.exports = __webpack_public_path__ + "media/images/ln/num_1-4dbeaf54f3c749dd8f9f5f7f575896e5.png";